import { commonjsGlobal as p } from "./index135.mjs";
import { __module as i } from "./index168.mjs";
i.exports;
(function(f) {
  (function(l, x, m) {
    function v(t) {
      var n = this, o = "";
      n.next = function() {
        var r = n.x ^ n.x >>> 2;
        return n.x = n.y, n.y = n.z, n.z = n.w, n.w = n.v, (n.d = n.d + 362437 | 0) + (n.v = n.v ^ n.v << 4 ^ (r ^ r << 1)) | 0;
      }, n.x = 0, n.y = 0, n.z = 0, n.w = 0, n.v = 0, t === (t | 0) ? n.x = t : o += t;
      for (var e = 0; e < o.length + 64; e++)
        n.x ^= o.charCodeAt(e) | 0, e == o.length && (n.d = n.x << 10 ^ n.x >>> 4), n.next();
    }
    function u(t, n) {
      return n.x = t.x, n.y = t.y, n.z = t.z, n.w = t.w, n.v = t.v, n.d = t.d, n;
    }
    function a(t, n) {
      var o = new v(t), e = n && n.state, r = function() {
        return (o.next() >>> 0) / 4294967296;
      };
      return r.double = function() {
        do
          var w = o.next() >>> 11, s = (o.next() >>> 0) / 4294967296, c = (w + s) / (1 << 21);
        while (c === 0);
        return c;
      }, r.int32 = o.next, r.quick = r, e && (typeof e == "object" && u(e, o), r.state = function() {
        return u(o, {});
      }), r;
    }
    x && x.exports ? x.exports = a : this.xorwow = a;
  })(
    p,
    f
  );
})(i);
var h = i.exports;
export {
  h as x
};
